import { authentication } from '@dpgradio/creative'
import { useSignupStore } from '../store/signup'

export async function setAppCallbacks() {
  authentication.initialize()

  const signupStore = useSignupStore()
  authentication.onRadioTokenChange(() => {
    signupStore.checkUserSignedUp()
  })
}
